import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import { getMyHomeProfit as _getMyHomeProfit } from '../../services/getMyHomeProfit';
import { IHowToEarnSchema } from '../../repositories/price-estimator/entities/how_to_earn/HowToEarnSchema';
import { selectMyHomeId } from '../../selectors/selectMyHomeId';

export const getMyHomeProfit = createAsyncThunk<IHowToEarnSchema | null, undefined, IThunkApi>(
  'getMyHomeProfit',
  async (_, _thunkApi) => {
    const { extra, getState } = _thunkApi;

    const myHomeId = selectMyHomeId(getState());

    const response = await _getMyHomeProfit(extra, myHomeId);

    return response;
  },
);
